import {useTranslation} from 'react-i18next';
import {CourtMap} from '../components/CourtMap';
import type {AppState} from '../app/model';
export function SceneFallback({state}:{state:AppState}){const {t}=useTranslation();return <div className="scene-fallback" role="alert"><p>{t('loadError')}</p><div className="fallback-map"><CourtMap state={state}/></div><p>{t('flatView')}</p><button className="primary" onClick={()=>location.reload()}>{t('retry')}</button></div>;}
